import * as API from "./apis";
import * as URL from "../Constants.URL";

export const MAIL_ADMIN_AUTO_TICKET_CREATOR = "info@aiset.io";
export const CRAFT_FILE_URL_NO_ORIGIN = (_id, name) => `${API.FILE_API}get/${_id}/${name}`;
export const CRAFT_FILE_URL_BACKEND = (_id, name) => `${URL.APP_DOMAIN}${API.FILE_API}get/${_id}/${name}`;
export const CRAFT_FILE_URL = (_id, name) => `${window?.location?.origin}${API.FILE_API}get/${_id}/${name}`;